import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function TradeOrdersScreen() {
  const navigate = useNavigate();
  
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [target, setTarget] = useState('');
  const [stoploss, setStoploss] = useState('');
  const [showedit, setShowedit] = useState(false);
  
  const [total, setTotal] = useState(0);
  const [selectedTab, setSelectedTab] = useState('Open');
  const [openOrders, setOpenOrders] = useState([]);
  const [closedOrders, setClosedOrders] = useState([]);
  const [username, setUsername] = useState('');
  const [client_id, setClientId] = useState('');
  const [usd, setUsd] = useState(1);
  const [walletUSD, setWalletUSD] = useState(0);
  const [loading, setLoading] = useState(true);
  
  const [lev, setLev] = useState(0);
  const [editId, setEditId] = useState('');
  const [edit_pair, setEditPair] = useState('');
  const [edit_profit_loss, setEditProfitLoss] = useState('');
  const [edit_buy_price, setEditBuyPrice] = useState('');
  const [edit_sell_price, setEditSellPrice] = useState('');
  const [edit_trade_type, setEditTradeType] = useState('');
  const [edit_live, setEditLive] = useState('');
  const [trade_status, setTradeStatus] = useState('');
  const [edit_lotsize, setEditLotsize] = useState('');
  const [hold_status, setHoldStatus] = useState(false);
  const [trd_sqoff, setTrd_sqoff] = useState(false);

  useEffect(() => {
    const initializeData = async () => {
      const userid = localStorage.getItem('userid');
      const name = localStorage.getItem('name');
      
      setUsername(name);
      setClientId(userid);
      
      await pageRefresh();
    };
    
    initializeData();
    
    if (selectedTab === 'Open') {
      const interval = setInterval(async () => {
        const userid = localStorage.getItem('userid');
        if (userid) {
          fetchOpenOrders(userid);
        }
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [selectedTab]);

  const pageRefresh = async () => {
    setLoading(true);
    try {
      const userid = localStorage.getItem('userid');
      
      const wurl = 'https://singlewindowsecurities.com/Rest3/wallet_api/' + userid;
      const walletResponse = await fetch(wurl);
      const walletJson = await walletResponse.json();
      setWalletUSD(walletJson.wallet || 0);
      
      const wurl4 = 'https://singlewindowsecurities.com/Rest3/company_profile_api';
      const rateResponse = await fetch(wurl4);
      const rateJson = await rateResponse.json();
      setUsd(rateJson.exchg_rate || 1);
      
      if (selectedTab === 'Open') {
        fetchOpenOrders(userid);
      } else if (selectedTab === 'Closed') {
        fetchClosedOrders(userid);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const fetchOpenOrders = async (userid) => {
    try {
      const url = 'https://singlewindowsecurities.com/Rest3/orders_api/Market/' + userid;
      const response = await fetch(url);
      const responseJson = await response.json();
      setOpenOrders(responseJson || []);

      const sum = responseJson.reduce(
        (acc, item) => acc + (item.used_margin || 0) * 1,
        0
      );
      setTotal(sum);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const fetchClosedOrders = async (userid) => {
    try {
      setLoading(true);
      const url = 'https://singlewindowsecurities.com/Rest3/orders_api/Exit/' + userid;
      const response = await fetch(url);
      const responseJson = await response.json();
      setClosedOrders(responseJson || []);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleTabPress = (tabName) => {
    setSelectedTab(tabName);
    if (tabName === 'Closed') {
      const fetchData = async () => {
        const userid = localStorage.getItem('userid');
        fetchClosedOrders(userid);
      };
      fetchData();
    } else if (tabName === 'Open') {
      const fetchData = async () => {
        const userid = localStorage.getItem('userid');
        fetchOpenOrders(userid);
      };
      fetchData();
    }
  };

  const editSubmit = async () => {
    if (target === '' || stoploss === '') {
      alert("Please Set Target & Stoploss");
      return false;
    }
    
    try {
      const formData = new FormData();
      formData.append('target', target);
      formData.append('stoploss', stoploss);
      formData.append('orderid', editId);

      const response = await fetch('https://singlewindowsecurities.com/Rest3/web_edit_trade_submit_api2/', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
        },
        body: formData,
      });
      
      const responseJson = await response.json();
      alert(responseJson.msg);
      
      if (responseJson.status === 0) {
        setEditModalVisible(false);
        setShowedit(false);
      }
    } catch (error) {
      console.log(error);
      alert("An error occurred while submitting the form");
    }
  };

  const edit_trade = async (id) => {
    setEditModalVisible(true);
    setLoading(true);
    try {
      const url = 'https://singlewindowsecurities.com/Rest3/edit_order_api/' + id;
      const response = await fetch(url);
      const responseJson = await response.json();
      
      setEditId(id);
      setEditPair(responseJson.cpair);
      if (responseJson.target === '') {
        // Don't auto-set target/stoploss
      } else {
        setTarget(responseJson.target);
        setStoploss(responseJson.stoploss);
      }
      setEditProfitLoss(responseJson.profit_loss);
      setEditBuyPrice(responseJson.buy_price);
      setEditSellPrice(responseJson.sell_price);
      setEditTradeType(responseJson.trade_type);
      setTradeStatus(responseJson.trade_status);
      setEditLive(responseJson.trade_price);
      setEditLotsize(responseJson.lotsize);
      setHoldStatus(responseJson.hold_status);
      setTrd_sqoff(responseJson.trd_sqoff);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const closeEditModal = () => {
    setTarget("");
    setStoploss("");
    setShowedit(false);
    setEditModalVisible(false);
  };

  const holdTrade = (id) => {
    if (window.confirm("Are you sure you want to Hold?")) {
      const urls = 'https://singlewindowsecurities.com/Rest3/sethold_forex/' + id;
      fetch(urls)
        .then(response => response.json())
        .then(responseJson => {
          alert("Trade is Hold");
        })
        .catch(error => {
          console.log(error);
          alert("Failed to convert to intraday");
        });
    }
  };

  const squareOff = async (id) => {
    if (window.confirm('Sure you want to Exit Order?')) {
      try {
        const url = `https://singlewindowsecurities.com/Rest3/square_off_api2/${id}`;
        const response = await fetch(url);
        const responseJson = await response.json();
        if (responseJson.status === 1) {
          navigate("/login");
        } else {
          setEditModalVisible(false);
          alert(responseJson.msg);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const getData = () => {
    switch (selectedTab) {
      case 'Open': return openOrders;
      case 'Closed': return closedOrders;
      default: return [];
    }
  };

  const calculateTotalPL = () => {
    if (selectedTab === 'Open') {
      return openOrders.reduce((total, item) => {
        const pl = parseFloat(item.profit_loss || 0);
        return total + (isNaN(pl) ? 0 : pl);
      }, 0).toFixed(2);
    } else {
      return closedOrders.reduce((total, item) => {
        const pl = parseFloat(item.profit_loss || 0);
        return total + (isNaN(pl) ? 0 : pl);
      }, 0).toFixed(2);
    }
  };

  const formatCurrency = (num) => {
    if (!num && num !== 0) return '0.00';
    return parseFloat(num).toFixed(2);
  };

  const renderOrder = (item) => (
    <div 
      key={item.trade_id}
      style={{
        background: 'rgba(20, 20, 20, 0.95)',
        borderRadius: '20px',
        border: '1px solid rgba(212, 175, 55, 0.15)',
        marginBottom: '12px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        overflow: 'hidden'
      }}
      onClick={() => edit_trade(item.trade_id)}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#D4AF37';
        e.currentTarget.style.transform = 'translateX(4px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.15)';
        e.currentTarget.style.transform = 'translateX(0)';
      }}
    >
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div className="d-flex align-items-center flex-grow-1">
            <div style={{
              width: '40px',
              height: '40px',
              background: item.trade_type === "BUY" ? 'rgba(0, 200, 83, 0.15)' : 'rgba(255, 82, 82, 0.15)',
              borderRadius: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '12px'
            }}>
              <i className={`fa fa-arrow-${item.trade_type === "BUY" ? 'up' : 'down'}`} 
                 style={{ color: item.trade_type === "BUY" ? '#00C853' : '#FF5252', fontSize: '18px' }}></i>
            </div>
            <div className="flex-grow-1">
              <h6 className="mb-0 fw-bold" style={{ color: '#D4AF37' }}>{item.cpair}</h6>
              <div className="d-flex align-items-center gap-2 mt-1">
                <span style={{
                  background: item.trade_type === "BUY" ? 'rgba(0, 200, 83, 0.15)' : 'rgba(255, 82, 82, 0.15)',
                  color: item.trade_type === "BUY" ? '#00C853' : '#FF5252',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '10px',
                  fontWeight: 'bold'
                }}>
                  {item.trade_type.toUpperCase()}
                </span>
                <small style={{ color: '#888' }}>{item.lotsize} LOT</small>
              </div>
            </div>
          </div>
          
          <div className="text-end">
            <h5 className={`mb-0 fw-bold ${item.profit_loss && parseFloat(item.profit_loss) >= 0 ? 'text-golden' : 'text-danger'}`} 
                style={{ color: item.profit_loss && parseFloat(item.profit_loss) >= 0 ? '#00C853' : '#FF5252' }}>
              ${item.profit_loss}
            </h5>
            <small style={{ color: '#888' }}>{item.trade_start_time}</small>
          </div>
        </div>
        
        <div style={{
          background: 'rgba(26, 26, 26, 0.6)',
          borderRadius: '16px',
          padding: '10px',
          marginTop: '8px'
        }}>
          <div className="row text-center">
            <div className="col-4">
              <small style={{ color: '#888', fontSize: '10px' }}>OPEN</small>
              <div className="fw-bold" style={{ color: '#D4AF37', fontSize: '13px' }}>{item.trade_price}</div>
            </div>
            <div className="col-4">
              {item.hold_status === 'On' && item.trade_status === 'Market' ? (
                <span style={{ color: '#D4AF37', fontWeight: 'bold', fontSize: '11px' }}>HOLD</span>
              ) : null}
            </div>
            <div className="col-4">
              <small style={{ color: '#888', fontSize: '10px' }}>{item.trade_status === 'EXIT' ? 'EXIT' : 'LIVE'}</small>
              <div className={`fw-bold ${item.trade_type === "BUY" ? 'text-success' : 'text-danger'}`} 
                   style={{ fontSize: '13px', color: item.trade_type === "BUY" ? '#00C853' : '#FF5252' }}>
                {item.trade_type === "BUY" ? item.sell_price : item.buy_price}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if (loading && getData().length === 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#0a0a0a' }}>
        <div className="text-center">
          <div className="spinner-border" style={{ color: '#D4AF37' }} role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3" style={{ color: '#D4AF37' }}>Loading orders...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0" style={{ 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
    }}>
      {/* Header */}
      <div style={{
        background: 'rgba(10, 10, 10, 0.95)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}>
        <div className="container py-3">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div style={{
                width: '44px',
                height: '44px',
                background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <span className="fw-bold" style={{ color: '#000' }}>FRX</span>
              </div>
              <div className="ms-3">
                <h5 className="fw-bold mb-0" style={{ color: '#D4AF37' }}>FOREX Orders</h5>
                <small style={{ color: '#888' }}>All Your Trading History</small>
              </div>
            </div>
            
            <span style={{
              background: 'rgba(212, 175, 55, 0.15)',
              color: '#D4AF37',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '11px',
              fontWeight: 'bold',
              border: '1px solid rgba(212, 175, 55, 0.3)'
            }}>
              LIVE DATA
            </span>
          </div>
        </div>
      </div>

      {/* Stats Section - Dark Golden */}
      <div className="container mt-3">
        <div style={{
          background: 'linear-gradient(145deg, rgba(212, 175, 55, 0.15), rgba(184, 150, 12, 0.05))',
          borderRadius: '24px',
          padding: '20px',
          border: '1px solid rgba(212, 175, 55, 0.2)',
          marginBottom: '16px'
        }}>
          <div className="row">
            <div className="col-6">
              <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '10px' }}>BALANCE</small>
              <h4 className="fw-bold mb-2" style={{ color: '#D4AF37' }}>${(walletUSD / usd).toFixed(2)}</h4>
              <small style={{ color: '#888', fontSize: '10px' }}>LEVERAGE</small>
              <div className="fw-bold" style={{ color: '#D4AF37' }}>${(walletUSD * 10 / usd).toFixed(2)}</div>
            </div>
            <div className="col-6 text-end">
              <small style={{ color: '#D4AF37', letterSpacing: '1px', fontSize: '10px' }}>LIVE P&L</small>
              <h3 className={`fw-bold mb-0 ${parseFloat(calculateTotalPL()) >= 0 ? 'text-success' : 'text-danger'}`}
                  style={{ color: parseFloat(calculateTotalPL()) >= 0 ? '#00C853' : '#FF5252' }}>
                {parseFloat(calculateTotalPL()) >= 0 ? '+' : ''}{calculateTotalPL()}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="container mt-2">
        <div className="d-flex gap-2 p-1" style={{
          background: 'rgba(20, 20, 20, 0.8)',
          borderRadius: '30px',
          border: '1px solid rgba(212, 175, 55, 0.15)'
        }}>
          <button
            className={`btn flex-fill py-2 ${selectedTab === 'Open' ? 'btn-golden' : ''}`}
            onClick={() => handleTabPress('Open')}
            style={{
              background: selectedTab === 'Open' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
              border: 'none',
              borderRadius: '30px',
              color: selectedTab === 'Open' ? '#000' : '#888',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
          >
            Open Orders
          </button>
          <button
            className={`btn flex-fill py-2 ${selectedTab === 'Closed' ? 'btn-golden' : ''}`}
            onClick={() => handleTabPress('Closed')}
            style={{
              background: selectedTab === 'Closed' ? 'linear-gradient(145deg, #D4AF37, #B8960C)' : 'transparent',
              border: 'none',
              borderRadius: '30px',
              color: selectedTab === 'Closed' ? '#000' : '#888',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
          >
            Closed Orders
          </button>
        </div>
      </div>

      {/* Orders List */}
      <div className="container mt-3 pb-4">
        {/* Orders Count */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span style={{
            background: 'rgba(212, 175, 55, 0.1)',
            color: '#D4AF37',
            padding: '4px 10px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: 'bold'
          }}>
            <i className="fa fa-list me-1"></i>
            {getData().length} {selectedTab.toLowerCase()} orders
          </span>
          
          {selectedTab === 'Open' && openOrders.length > 0 && (
            <span style={{
              background: 'rgba(0, 200, 83, 0.15)',
              color: '#00C853',
              padding: '4px 10px',
              borderRadius: '12px',
              fontSize: '11px',
              fontWeight: 'bold'
            }}>
              <i className="fa fa-circle-fill me-1" style={{ fontSize: '8px' }}></i>
              Live Updates
            </span>
          )}
        </div>

        {/* Orders Content */}
        {getData().length > 0 ? (
          <div>
            {getData().map(item => renderOrder(item))}
          </div>
        ) : (
          <div style={{
            background: 'rgba(20, 20, 20, 0.95)',
            borderRadius: '24px',
            border: '1px solid rgba(212, 175, 55, 0.15)',
            textAlign: 'center',
            padding: '48px 24px'
          }}>
            <div style={{
              width: '70px',
              height: '70px',
              background: 'rgba(212, 175, 55, 0.1)',
              borderRadius: '35px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <i className="fa fa-file-text" style={{ color: '#D4AF37', fontSize: '32px' }}></i>
            </div>
            <h5 className="fw-bold mb-2" style={{ color: '#fff' }}>No {selectedTab.toLowerCase()} positions</h5>
            <p style={{ color: '#888' }}>
              {selectedTab === 'Open' 
                ? 'Start trading to see your open positions here'
                : 'Closed trades will appear here'}
            </p>
          </div>
        )}
      </div>

      {/* Edit Modal */}
      {editModalVisible && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content" style={{
              background: '#1a1a1a',
              borderRadius: '24px',
              border: '1px solid rgba(212, 175, 55, 0.2)'
            }}>
              <div className="modal-header" style={{ borderBottom: '1px solid rgba(212, 175, 55, 0.1)' }}>
                <div className="d-flex align-items-center">
                  <div style={{
                    width: '36px',
                    height: '36px',
                    background: edit_trade_type === "BUY" ? 'rgba(0, 200, 83, 0.15)' : 'rgba(255, 82, 82, 0.15)',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '12px'
                  }}>
                    <i className={`fa fa-arrow-${edit_trade_type === "BUY" ? 'up' : 'down'}`} 
                       style={{ color: edit_trade_type === "BUY" ? '#00C853' : '#FF5252' }}></i>
                  </div>
                  <div>
                    <h5 className="modal-title fw-bold mb-0" style={{ color: '#D4AF37' }}>{edit_pair}</h5>
                    <small style={{ color: edit_trade_type === "BUY" ? '#00C853' : '#FF5252', fontWeight: 'bold' }}>
                      {edit_trade_type} • {edit_lotsize} LOT
                    </small>
                  </div>
                </div>
                <button type="button" className="btn-close btn-close-white" onClick={closeEditModal}></button>
              </div>
              
              <div className="modal-body p-4">
                {!showedit ? (
                  <>
                    <div style={{
                      background: 'rgba(26, 26, 26, 0.8)',
                      borderRadius: '16px',
                      padding: '16px',
                      marginBottom: '20px',
                      border: '1px solid rgba(212, 175, 55, 0.1)'
                    }}>
                      <div className="d-flex justify-content-between mb-2">
                        <small style={{ color: '#888' }}>Entry Price</small>
                        <span className="fw-bold" style={{ color: '#D4AF37' }}>{edit_live}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <small style={{ color: '#888' }}>Current Price</small>
                        <span className={`fw-bold ${edit_trade_type === "BUY" ? 'text-success' : 'text-danger'}`}
                              style={{ color: edit_trade_type === "BUY" ? '#00C853' : '#FF5252' }}>
                          {edit_trade_type === "BUY" ? edit_buy_price : edit_sell_price}
                        </span>
                      </div>
                      <div className="d-flex justify-content-between">
                        <small style={{ color: '#888' }}>Profit/Loss</small>
                        <span className={`fw-bold ${edit_profit_loss && parseFloat(edit_profit_loss) >= 0 ? 'text-success' : 'text-danger'}`}
                              style={{ color: edit_profit_loss && parseFloat(edit_profit_loss) >= 0 ? '#00C853' : '#FF5252' }}>
                          {edit_profit_loss}
                        </span>
                      </div>
                    </div>

                    {trade_status == 'Market' && hold_status != 'On' && trd_sqoff != 'Off' && (
                      <div className="d-flex gap-3">
                        <button
                          className="btn flex-fill py-2"
                          onClick={() => squareOff(editId)}
                          style={{
                            background: 'linear-gradient(145deg, #FF5252, #D32F2F)',
                            border: 'none',
                            borderRadius: '12px',
                            color: '#fff',
                            fontWeight: 'bold'
                          }}
                        >
                          MARKET EXIT
                        </button>
                        
                        <button
                          className="btn flex-fill py-2"
                          onClick={() => setShowedit(true)}
                          style={{
                            background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                            border: 'none',
                            borderRadius: '12px',
                            color: '#000',
                            fontWeight: 'bold'
                          }}
                        >
                          SET LIMIT
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <h6 className="fw-bold mb-3" style={{ color: '#D4AF37' }}>Set Target & Stop Loss</h6>
                    
                    <div className="mb-3">
                      <label className="form-label small" style={{ color: '#888' }}>TARGET ($)</label>
                      <input
                        type="number"
                        className="form-control"
                        style={{
                          background: '#1a1a1a',
                          border: '1px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px',
                          color: '#fff'
                        }}
                        value={target}
                        onChange={(e) => setTarget(e.target.value)}
                      />
                    </div>
                    
                    <div className="mb-4">
                      <label className="form-label small" style={{ color: '#888' }}>STOP LOSS ($)</label>
                      <input
                        type="number"
                        className="form-control"
                        style={{
                          background: '#1a1a1a',
                          border: '1px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px',
                          color: '#fff'
                        }}
                        value={stoploss}
                        onChange={(e) => setStoploss(e.target.value)}
                      />
                    </div>

                    <div className="d-flex gap-3">
                      <button
                        className="btn flex-fill py-2"
                        onClick={() => setShowedit(false)}
                        style={{
                          background: 'rgba(212, 175, 55, 0.1)',
                          border: '1px solid rgba(212, 175, 55, 0.3)',
                          borderRadius: '12px',
                          color: '#D4AF37',
                          fontWeight: 'bold'
                        }}
                      >
                        BACK
                      </button>
                      
                      <button
                        className="btn flex-fill py-2"
                        onClick={editSubmit}
                        style={{
                          background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                          border: 'none',
                          borderRadius: '12px',
                          color: '#000',
                          fontWeight: 'bold'
                        }}
                      >
                        SUBMIT
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          .btn-golden {
            background: linear-gradient(145deg, #D4AF37, #B8960C);
            transition: all 0.3s ease;
          }
          .btn-golden:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
          }
          input:focus {
            box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.3) !important;
            outline: none;
            border-color: #D4AF37 !important;
          }
        `}
      </style>
    </div>
  );
}